
import * as React from "react";
import { IOffer, IOfferSaveData } from "../../../interfaces/IOffer";
import { Api } from "../../../lib/Api";
import { IDelivery } from "../../../interfaces/IDelivery";
import DeliveryBox from "../restaurant/DeliveryBox";
import { Checkbox } from "../../../../avernus/checkbox/source/Checkbox";
import OpeningHours from "../../global/OpeningHours";
import { IDeliveryForSave } from "../../../interfaces/IRestaurant";
import { CalcSobransCredit } from "./CalcSobransCredit";
import InputTime from "../../global/InputTime";

interface ICreateOfferProps {
    changed             : Function
    restaurantId        : number
}

interface ICreateOfferState extends IInitResult {
    success             : string
    error               : string
    price               : number
    currency            : string
    offerTypeId         : number
}

interface ISaveOffer{
    id      ?: number
    success : string
    error   : string
}

interface IGetXHR{
    form: IOffer
}

interface IOption{
    name: string
    value:string
}
interface IOfferTYpeOption{
    name: string
    id:string
}

interface IInitResult{
    offerTypeOptions: Array<IOfferTYpeOption>
}

export default class CreateOffer extends React.Component<ICreateOfferProps, ICreateOfferState> {
    constructor(props:ICreateOfferProps){
        super(props);
        this.state = {
            success                 : null,
            error                   : null,
            offerTypeOptions        : [],
            price                   : 0,
            currency                : '$',
            offerTypeId             : 1
        };
        this.init();
    }

    private init(){
        Api.call('/restaurants/offers/init', {
            restaurantId: this.props.restaurantId
        }, (result:IInitResult) =>{
            this.setState({
                offerTypeOptions: result.offerTypeOptions,
            });
        } );

    }

    private submitHandler(): void {

        let saveUrl:string  = '/restaurants/offers/create';

        Api.call(saveUrl, {
            restaurantId: this.props.restaurantId,
            originalPrice: this.state.price,
            offerTypeId: this.state.offerTypeId,
            originalPriceCurrency: 'USD'
        }, (result:ISaveOffer)=>{
            this.setState({
                success:    result.success,
                error:      result.error,
            }, () =>{
                if ( result.success ) {
                    this.props.changed(true);
                }
            });
        });
    }

    private changePriceHandler(evt): void {
        evt.preventDefault();
        this.setState({
            price: parseFloat(evt.target.value)
        });
    }

    private increasePriceModifier(evt, increase:boolean):void{
        evt.preventDefault();
        let price = this.state.price;
        if ( increase === true  ) {
            ++ price;
        }else{
            -- price;
        }
        if ( price < 0 ) {
            price = 0;
        }
        this.setState({
            price: price
        });
    }

    private changeOfferType(value){
        this.setState({
            offerTypeId: value
        });
    }

    render(){
        return (
            <div className = "create-offer-box">
                <img src = "img/create_offer_icon.png" />
                <h1>Add new service</h1>
                <div className="row">
                    <div className="col-12">
                        <div className="form-row">
                            <div className="col">
                                <select className="s-form-control" required={true} name="offerType" defaultValue={ this.state.offerTypeId } onChange = {(e) => this.changeOfferType(e.target.value)}>
                                    <option value="">Type</option>
                                    { this.state.offerTypeOptions.map((item, key:number) => {
                                        return <option key={key} value={item.id}>
                                            { item.name }
                                        </option>
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="form-row label_row">
                            <div className="col text-center">
                                price:
                            </div>
                        </div>
                        <div className="form-row modifier_row">
                            <div className="col text-right">
                                <a className="btn price_minus_btn" onClick={ (e) => { this.increasePriceModifier(e, false); } }>
                                    -
                                </a>
                            </div>
                            <div className="col-5 price-field">
                                {this.state.price}{ this.state.currency }
                            </div>
                            <div className="col text-left">
                                <a className="btn price_plus_btn" onClick={ (e) => { this.increasePriceModifier(e, true); } }>
                                    +
                                </a>
                            </div>
                        </div>
                        <div className="form-row">
                            <button className="purple_btn" onClick={() => this.submitHandler()}>
                                Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
